import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import IpadNavigation from 'Navigation/IpadNavigation'
import More from 'More/views/MoreView/containers/Smartphones'
import { CapcitoOnboarding } from 'MarketPlace/Capcito/views/CapcitoOnboardingView/containers/Smartphones'

class CapcitoOnboardingView extends Component {
  static propTypes = {
    t: PropTypes.func,
    tSettings: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired
  }

  render () {
    const { t, location } = this.props
    const navBarTitle = t('capcitoOnboarding', 'title').s

    return (
      <IpadNavigation title={navBarTitle} location={location} withoutMaxWidth>
        <More notRightIcon isIpad />
        <CapcitoOnboarding {...this.props} />
      </IpadNavigation>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    t: state.i18n.get('app', 'views', 'MarketPlace'),
    tSettings: state.i18n.get('app', 'views', 'MarketPlace', 'common', 'fields')
  }
}

export default connect(mapStateToProps)(CapcitoOnboardingView)
